import * as React from "react";
import { Show, SimpleShowLayout, useRecordContext, Button, TextField, FunctionField } from 'react-admin';
const PageTitle = () => {
  const record = useRecordContext();
  return <span>Payment proof for {record ? `${record.profile_id}` : ''}</span>;
};
const UploadPaymentProofDetail = ({ ...props }) => (

  <Show title={<PageTitle />} {...props}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="profile_id" label="Profile Id" />
      <TextField source="name" label="Name" />
      <TextField source="payment_credited_date" label="Payment credited date" />
      <TextField source="payment_type" label="Payment type" />
      <TextField source="request_amount" label="Request Amount" />
      <TextField label="Received amount" source="received_amount" />
      <TextField label="Published by" source="publishedby.name" />
       <TextField label="Published Date" source="punlished_date" />
      <TextField label="Rejected by" source="rejectedby.name" />
      <TextField label="Rejected Reason" source="reason" />
      <FunctionField source="status" label="Status" render={record => {
        if (record['status'] === 'Rejected') {
          return (<Button style={{ color: 'red', border: '1px solid' }} label="Rejected" size="small"></Button>)
        } else if (record['status'] === 'Pending') {
          return (<Button style={{ color: 'orange', border: '1px solid' }} label="Pending" size="small"></Button>)
        } else if (record['status'] === 'Published') {
          return (<Button style={{ color: 'green', border: '1px solid' }} label="Published" size="small"></Button>)
        }
      }} />
      <FunctionField source="credited_proof" label="Proof" render={record => {
        if (record['credited_proofurl']) {
          return (<span>Proof <br /><br /><img style={{ maxWidth: '100px' }} src={record['credited_proofurl']} alt={record.name} /></span>)
        }
      }} />
       <TextField label="Feedback" source="feedback" />
    </SimpleShowLayout>
  </Show>
);
export default UploadPaymentProofDetail